import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20soft%20gradient%20light%20rays%20and%20bokeh%20effect%2C%20dark%20theater%20ambiance%20with%20golden%20highlights%2C%20artistic%20minimal%20style%2C%20warm%20coral%20and%20amber%20accents%2C%20dreamy%20atmosphere%2C%20suitable%20for%20video%20streaming%20platform%20hero%20background&width=1800&height=900&seq=hero-bg-video-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 bg-primary-500/20 backdrop-blur-sm border border-primary-500/30 rounded-full text-primary-300 text-sm font-medium mb-6">
            <i className="ri-flashlight-line mr-1.5"></i>全新4K超清体验已上线
          </span>
        </div>

        <h1 className="animate-fade-in-up animation-delay-100 text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
          极速高清
          <span className="block text-primary-400 mt-2">随时随地畅享精彩内容</span>
        </h1>

        <p className="animate-fade-in-up animation-delay-200 text-sm md:text-base text-background-200/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          无需下载，支持手机、平板、电脑多端同步。海量高清影视、综艺、纪录片随时在线观看，
          超低延迟、超清画质，让每一次在线观看体验都流畅无卡顿。
        </p>

        <div className="animate-fade-in-up animation-delay-300 flex flex-col sm:flex-row items-center justify-center gap-3 mb-12">
          <Link
            to="/category/dianying"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
          >
            <i className="ri-play-circle-line mr-2"></i>立即在线观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/20 text-background-50 rounded-full text-base font-medium hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>了解更多
          </Link>
        </div>

        <div className="animate-fade-in-up animation-delay-400 grid grid-cols-3 gap-6 md:gap-12 max-w-lg mx-auto">
          {[
            { value: '12,000+', label: '高清内容' },
            { value: '5000万+', label: '活跃用户' },
            { value: '99.9%', label: '播放成功率' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-xl md:text-3xl font-bold text-background-50 font-heading">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-300/70 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;